import { render, staticRenderFns } from "./UserProfileSubscribedUserReferral.vue?vue&type=template&id=b45230fc"
import script from "./UserProfileSubscribedUserReferral.vue?vue&type=script&lang=js"
export * from "./UserProfileSubscribedUserReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports